var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.175 10 3.583-3.575a.837.837 0 0 0-1.183-1.183L10 8.825 6.425 5.242a.837.837 0 1 0-1.183 1.183l3.583 3.576-3.583 3.575a.833.833 0 0 0 0 1.183.833.833 0 0 0 1.183 0L10 11.175l3.575 3.584a.833.833 0 0 0 1.183 0 .833.833 0 0 0 0-1.184l-3.583-3.574Z"
  })));
};
export default SvgClose;